export const LEAD_CATEGORY = "LEAD_CATEGORY";
export const SUPPLY_NAME = "SUPPLY_NAME";
export const RWA_TENURE = "RWA_TENURE";
export const SUPPLY_DROP_DOWN = "SUPPLY_DROP_DOWN";
export const CORPORATE_DROP_DOWN = "CORPORATE_DROP_DOWN";
export const B2B_DROP_DOWN = "B2B_DROP_DOWN";
